import { useContext } from "react";
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { applicationContext } from "helpers/services";
import { ticketsContext } from "views/Tickets/TicketsContext";
import Clickable from "./components/ClickableStatus";
import { ticketsDashboardContext } from "./TIcketsDashboardContext";

let TicketsDashboard = () => {
    let { ticketTypes, ticketStatuses } = useContext(applicationContext)
    let { supplier } = useContext(ticketsContext)
    let { ticketsDashboard } = useContext(ticketsDashboardContext)


    return (
        <>
            <Typography variant="h4">Ticket by status</Typography>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Status</TableCell>
                        {ticketTypes.map((x) => <TableCell key={x.id} align="right">{x.name}</TableCell>)}
                        <TableCell align="right">Total</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {ticketStatuses
                        .filter(status => status.isResolved === false)
                        .map((ticketStatus) =>
                            <TableRow key={ticketStatus.id} hover>
                                <TableCell component="th" scope="row">
                                    {ticketStatus.name}
                                </TableCell>
                                {ticketTypes.map((y) =>
                                    <TableCell key={y.id} align="right">
                                        <Clickable
                                            supplier={supplier}
                                            value={ticketsDashboard.find(z => z.type === y.id && z.status === ticketStatus.id)?.count || 0}
                                            status={ticketStatus.id}
                                            type={y.id}
                                        />
                                    </TableCell>
                                )}
                                <TableCell align="right">
                                    <b>
                                        <Clickable
                                            supplier={supplier}
                                            value={ticketsDashboard.filter((p => p.status === ticketStatus.id)).sum((p) => p.count) || 0}
                                            status={ticketStatus.id}
                                        />
                                    </b>
                                </TableCell>
                            </TableRow>
                        )}
                    <TableRow hover>
                        <TableCell><b>Total</b></TableCell>
                        {ticketTypes.map(x =>
                            <TableCell key={x.id} align="right">
                                <b>
                                    <Clickable
                                        supplier={supplier}
                                        value={ticketsDashboard.filter(p => p.type === x.id).sum(p => p.count) || 0}
                                        type={x.id}
                                    />
                                </b>
                            </TableCell>
                        )}
                        <TableCell align="right">
                            <b>
                                <Clickable
                                    supplier={supplier}
                                    value={ticketsDashboard.sum(p => p.count)}
                                />
                            </b>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </>
    )
}

export default TicketsDashboard;